/* "(?=x*)\1" is equivalent to "x*+" (possessive quantifier) */
export const NameRegex = /^\s*?(?!\s)((?=(\p{L}\p{M}*))\2|[\-_'\s])+\s*$/mu;
export const NameNumberRegex = /^\s*?(?!\s)((?=(\p{L}\p{M}*))\2|[\p{Nd}\-_'\s])+\s*$/mu;
export const NumberOnlyRegex = /^\d*$/;
export const NumberOnlyRequiredRegex = /^[0-9]+$/;
